<table class="table table-bordered">
  <tr *ngFor="let c of value">
    <td>
      <button class="btn btn-sm btn-link text-danger float-right" aria-label="Remove Collaborator" (click)="remove(c)">
        <i class="fa fa-times"></i>
      </button>

      <a (click)="edit(c)" class="href mb-2">
        {{c.name}}
      </a>

      <div class="text-sm pl-1">
        <div [ngSwitch]="c.institution.type">
          <div *ngSwitchCase="CollaboratorInstitutionType.LandGrant">
            <i class="fa fa-map-marker fa-fw text-muted"></i>
            {{c.institution.name}} ({{c.institution.stateId}})
          </div>
          <div *ngSwitchCase="CollaboratorInstitutionType.Tribal">
            <i class="fa fa-map-marker fa-fw text-muted"></i>
            {{c.institution.name}}
          </div>
          <div *ngSwitchCase="CollaboratorInstitutionType.Other">
            <i class="fa fa-location-arrow fa-fw text-muted"></i>
            {{c.institution.institutionName}}
          </div>
          <div *ngSwitchCase="CollaboratorInstitutionType.Other">
            <i class="fa fa-globe fa-fw text-muted"></i>
            {{ c.institution.countryName || 'U.S.' }}
          </div>
          <div *ngSwitchCase="CollaboratorInstitutionType.Campus">
            <i class="fa fa-graduation-cap fa-fw text-muted"></i>
            {{c.institution.name}}
          </div>        
        </div>
        <div *ngIf="!!c.websiteAddress">
          <i class="fa fa-link fa-fw text-muted"></i>
          <a [href]="c.websiteAddress" target="_blank">
            {{c.websiteAddress}}
          </a>
        </div>
        <div *ngIf="!!c.emailAddress">
          <i class="fa fa-envelope fa-fw text-muted"></i>
          <a href="mailto:{{c.emailAddress}}">
            {{c.emailAddress}}
          </a>
        </div>
      </div>
    </td>
  </tr>
</table>